<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" key="logoutConfirm" acceptLabel="Oui" rejectLabel="Non">
</p-confirmDialog>
<nav class="navbar navbar-light navbar-expand bg-white shadow mb-4 topbar static-top fixed-top">
  <div class="container-fluid">
    <ul class="nav navbar-nav flex-nowrap ml-auto" style="margin-left: 1px !important;/*margin-right: 50px;*/">
      <li class="nav-item dropdown no-arrow">
        <a class="dropdown-toggle nav-link nav-link" data-toggle="dropdown" aria-expanded="false" href="#" (click)="showSideBar()">
          <i class="fas fa-bars text-yellow1" style="font-size: 18px;padding: 8px 9px;background-color: #f9f9f9;border-radius: 50px;color: #e54c4b;"></i>
        </a>
        <!--Menu gauche flottant-->
        <app-side-menu *ngIf="slidMenuVisible" (close)="onSideBarClose()" [delayClickOutsideInit]="true" (clickOutside)="slidMenuVisible=false"></app-side-menu>
      </li>
    </ul>
    <div class="d-none d-sm-block topbar-divider"></div>
    <div class="d-sm-flex d-md-flex d-xl-flex align-items-sm-center align-items-xl-center" id="logoBlock"><img src="assets/v2/img/EPC-logo.svg" style="height: 40px;"></div>
    
    <!-- Message de connexion externe -->
    <div *ngIf="isExternalLogin" class="d-none d-md-flex align-items-center" style="margin-left: 20px; padding: 8px 16px; background-color: #fff3cd; border-radius: 4px; border-left: 4px solid #ffc107;">
      <i class="fas fa-info-circle" style="color: #856404; margin-right: 8px;"></i>
      <span style="color: #856404; font-size: 13px; font-weight: 500;">
        Connexion externe sur l'espace pro - {{externalUserEmail}}
      </span>
    </div>
    
    <ul class="nav navbar-nav flex-nowrap ml-auto">
      <li class="nav-item dropdown no-arrow">

        <div class="dropdown-toggle nav-link nav-link" data-toggle="dropdown" aria-expanded="false" href="#">
          <span class="fulscreenIcon"> <i class="fas fa-expand fa-lg" (click)="this.showOrNotFullScreen()" pTooltip="plein écran" tooltipPosition="left"> </i>  </span>
          <span class="d-none d-lg-inline mr-2 small" style="color: #222222;">
            Bonjour
          </span><span class="d-none d-lg-inline mr-2 small" style="color: #222222;">{{fullName}}</span>
          <a (click)="showAccountMenu()"><img class="border rounded-circle img-profile" src="assets/v2/img/avatars/profile.png"></a>
        </div>
        <app-account-menu *ngIf="accountMenuVisible" [delayClickOutsideInit]="true"
                          (close)="accountMenuVisible=false" (clickOutside)="accountMenuVisible=false"></app-account-menu>
      </li>
    </ul>
  </div>
</nav>
